import React from 'react'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive'
import DragSvg from '../../assets/v2/JSX/DragSvg'
//
//
const DraggableHorizontalCard: React.FC<{
  onClick?: () => void
  title?: string
  description?: string
  disabled?: boolean
  saleText?: string | number
  className?: string
}> = ({ onClick, title, description, disabled = false, saleText, className }) => {
  //
  //
  return (
    <Wrapper $sale={saleText ? true : false} $disabled={disabled} onClick={onClick} className={className}>
      {saleText && <Sale>{saleText}</Sale>}
      <Content className="horizontal-card-content">
        <DragSvg />
        <TextBlock>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </TextBlock>
      </Content>
    </Wrapper>
  )
}
//

const Sale = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Colors.lightRed};
  font-size: 14px;
  color: ${Colors.primaryRed};
  padding: 9px 20px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;

  ${Responsive.mobile} {
    padding: 8px 18px;
  }
`
const Description = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 0px;
  margin-right: 45px;

  ${Responsive.mobile} {
    margin-right: 0px;
  }
`
const Title = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 7px;
  margin-top: 6px;

  ${Responsive.mobile} {
    margin-bottom: 5px;
  }
`
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 30px;
  width: 100%;

  ${Responsive.mobile} {
    align-items: left;
    text-align: center;
    padding-left: 20px;
  }
`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px 0px 10px 24px;

  ${Responsive.mobile} {
    /* justify-content: flex-start; */
    padding: unset;
  }
`
const Wrapper = styled.div<{ $disabled: boolean; $sale: boolean }>`
  /* max-width: 464px; */
  width: 100%;
  user-select: none;

  /* disable */
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'unset')};
  opacity: ${({ $disabled }) => ($disabled ? '0.8' : 'unset')};
  /* disable */

  position: relative;
  outline: 'unset';
  box-shadow: ${`0 4px 50px 0 ${Colors.shadow}`};
  background-color: ${Colors.white};
  border-radius: 8px;
  cursor: pointer;
  padding: 30px 32px;
  padding: ${({ $sale }) => ($sale ? '50px 32px' : `30px 32px`)};

  ${Responsive.mobile} {
    padding: 24px;
  }
`
//
export default DraggableHorizontalCard
